import type { JSX } from "react";

import { Stack } from "@mantine/core";

import { HandshakeAnimation } from "../../../../shared-utils/common-ui/animations/handshake";
import { Header } from "../call-intro-flow/steps/Header";
import { ConversationalSummary } from "./ConversationalSummary";
import { getFormattedIntent } from "./getFormattedIntent";
import { IVRSummary } from "./IVRSummary";

interface CustomerHandoffProps {
    intent?: string;
    summary?: string;
    device?: string;
    productLink?: string;

    conversationalSummary?: string;
    customerName?: string;
}

export function CustomerHandoff({
    intent,
    summary,
    device,
    productLink,
    conversationalSummary,
    customerName,
}: CustomerHandoffProps): JSX.Element {
    const formattedIntent = getFormattedIntent({ device, intent });

    const showConversationalSummary = conversationalSummary && conversationalSummary.length > 0;
    const showIVRSummary = !showConversationalSummary && (formattedIntent || summary);
    return (
        <Stack gap={0}>
            <Stack align="center">
                <HandshakeAnimation width="40%" />
                <Header text="What we know" />
            </Stack>
            {showConversationalSummary && (
                <ConversationalSummary
                    intent={formattedIntent}
                    conversationalSummary={conversationalSummary}
                    customerName={customerName}
                />
            )}
            {showIVRSummary && <IVRSummary intent={formattedIntent} summary={summary} productLink={productLink} />}
        </Stack>
    );
}
